import type {ServiceCenterBannerResponse} from '@/api/bffSupport';
import type {Page} from '@/types';

import {lazy, Suspense} from 'react';

import {testId} from '@/utils/testId';

const ServiceCenterAgentBannerEnhanced = lazy(
  () =>
    import(
      '@/modules/common/components/ServiceBanner/ServiceCenterAgentBannerEnhanced'
    )
);

const ServiceCenterAgentBanner = lazy(
  () =>
    import('@/modules/common/components/ServiceBanner/ServiceCenterAgentBanner')
);

type Props = ServiceCenterBannerResponse & {
  offerCode?: string;
  page: Page;
  openingHours: string;
  treatment: string;
  virtualQWidgetUrl?: string;
};

export const ServiceBanner = ({treatment, ...restProps}: Props) => {
  if (treatment === 'enhancedAgentPicture') {
    return (
      <Suspense>
        <ServiceCenterAgentBannerEnhanced
          {...restProps}
          data-testid={testId('serviceCenterBanner')}
        />
      </Suspense>
    );
  }

  if (treatment === 'agentPicture') {
    return (
      <Suspense>
        <ServiceCenterAgentBanner
          {...restProps}
          data-testid={testId('serviceCenterBanner')}
        />
      </Suspense>
    );
  }

  return null;
};
